import { useContext } from "react"
import { GlobalContext } from "../Context/globalContext"
import { Triangle } from "react-loader-spinner";

export const Loader = () => {

    const globalContext = useContext(GlobalContext);

    return (
        <>
            <>
                {
                    globalContext.loader &&
                    <div className='loader'>
                        <Triangle color="#001E6C" height={80} width={80} />
                    </div>
                }
            </>
        </>
    )

}